import React from 'react'
import EAModal from "../Modal/EAModal";
import { DayPicker } from 'react-day-picker';
import useLocaleByLanguage from '../../../../utils/hooks/useLocaleByLanguage';
import { addYears } from 'date-fns';

interface IProps {
    title?: string;
    onClose: () => void;
    date?: Date;
    onDatePick: (date: Date) => void;
}

const EACalendarModal: React.FC<IProps> = ({ title= "Wybór dnia", onClose, date, onDatePick}) => {
    const locale = useLocaleByLanguage();
  return (
    <EAModal
    isOpen
    onClose={onClose}
    title={title}
    hideAcceptButton
  >
    <div className="eamodal__calendar">
      <DayPicker
        mode="single"
        locale={locale}
        fromDate={new Date()}
        selected={date}
        onSelect={(date) => onDatePick(date ? date : new Date())}
        showOutsideDays
        toDate={addYears(new Date(), 1)}
      />
    </div>
  </EAModal>
  )
}

export default EACalendarModal